import React from 'react';

interface TeacherSelectorProps {
  isDarkMode: boolean;
  selectedTeacher: string;
  onTeacherChange: (teacher: string) => void;
  teachers: string[];
}

const TeacherSelector: React.FC<TeacherSelectorProps> = ({ 
  isDarkMode, 
  selectedTeacher, 
  onTeacherChange,
  teachers 
}) => {
  return (
    <div className="teacher-selector">
      <select
        id="teacher-filter"
        value={selectedTeacher}
        onChange={(e) => onTeacherChange(e.target.value)}
        className={`teacher-dropdown ${isDarkMode ? 'dark' : ''}`}
        style={{
          padding: '6px 12px',
          borderRadius: '4px',
          border: `1px solid ${isDarkMode ? '#424242' : '#e0e0e0'}`,
          backgroundColor: isDarkMode ? '#2c2c2c' : '#ffffff',
          color: isDarkMode ? '#ffffff' : '#212121',
          fontSize: '14px',
          cursor: 'pointer',
          minWidth: '150px',
          outline: 'none',
        }}
      >
        <option value="all">Barcha o'qituvchilar</option>
        {teachers.map((teacher) => (
          <option key={teacher} value={teacher}>
            {teacher}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TeacherSelector;
